import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        lng: localStorage.getItem('lang') || 'fr',
        resources: {
            en: {
                guestmedia: {
                    upload_photo_n_video: "Upload Photos & Videos",
                    drag_n_drop: "Drag and drop your media",
                    select_files: "or click to select files",
                    choose_files: "Choose Files",
                    selected_files: "Selected Files",
                    cancel: "Cancel",
                    uploading: "Uploading...",
                    upload: "Upload"
                },
                media_gallery: {
                    title_media_gallery: "Media Gallery",
                    manage_image_n_video: "Manage your images and videos",
                    deleteMessage: "Delete data suceesfully",
                    delete_media: "Delete Media",
                    delete_media_description: "Are you sure you want to delete this media file? This action cannot be undone.",
                    cancel: "Cancel",
                    delete: "Delete",
                    add_media: "Add Media",
                    upload_media: "Upload Media",
                    choose_files_to_upload: "Choose files to upload",
                    drag_n_drop: "Or drag and drop • Images and videos only",
                    selected_files: "Selected Files",
                    upload: "Upload",
                    loading: "Loading...",
                    load_more: "Load More",
                    photo: "photo",
                    video: "video",
                    all: "All",
                    no_media_found: "No Media Found"
                },
                resetpassword: {
                    main_title: "Reset Password",
                    description: "Create a new password to secure your account.",
                    title: "Set New Password",
                    subtitle: "Enter your new password below.",
                    password_label: "New Password",
                    password_placeholder: "Enter new password",
                    confirm_password_label: "Confirm Password",
                    confirm_password_placeholder: "Re-enter new password",
                    submit_button: "Reset Password",
                    error_required: "All fields are required.",
                    error_mismatch: "Passwords do not match.",
                    error_generic: "Something went wrong.",
                    success_message: "Password has been reset successfully!"
                },
                forgotpassword: {
                    main_title: "Forgot Password?",
                    description: "Recover your account quickly and securely.",
                    title: "Reset Your Password",
                    subtitle: "Enter your email to receive a reset link",
                    email_label: "Email Address",
                    email_placeholder: "Enter your registered email",
                    submit_button: "Send Link",
                    signin_button: "Sign In",
                    remembered: "Remembered your password?",
                    error_empty: "Email is required.",
                    error_invalid: "Enter a valid email address.",
                    error_generic: "Something went wrong.",
                    success_message: "Password reset link sent successfully!"
                },
                navbar: {
                    greeting: 'Hi',
                    date_time: "It's July 22,2024. 4:24 p.m.",
                    profile: 'Profile',
                    logout: 'Log Out',
                    cancel: 'Cancel',
                    logoutConformation: 'Are you sure you want to logout?'
                },
                profilePage: {
                    profile: 'Profile',
                    name: 'Name',
                    placeholder_name: 'Enter Your Name',
                    email: 'Email',
                    placeholder_email: 'Enter Your Email',
                    phone_no: 'Phone No.',
                    placeholder_phone_no: 'Enter Your Phone no.',
                    address: 'Address',
                    placeholder_address: 'Enter Your Address',
                    postal_code: 'Postal Code',
                    placeholder_postal_code: 'Enter Your Postal Code',
                    city: 'City',
                    placeholder_city: 'Enter Your City',
                    cancel: 'Cancel',
                    save: 'Save'
                },
                dashboardLayout: {
                    dashboard: "Dashboard",
                    events: "Events",
                    configuration: "Your Emails",
                    addYourGuests: "Add your Guests",
                    yourGuests: "Your Guests",
                    rate: "Rate",
                    yourTestimonials: "Your Testimonials",
                    qrCode: "QR Code",
                    videoTutorials: "Video Tutorials",
                    contactUs: "Contact Us",
                    logOut: "Log Out",
                    cancel: "Cancel",
                    logoutConformation: "Are you sure you want to logout?"
                },
                event: {
                    headre: 'Events',
                    btn_create_event: 'Create Event',
                    btn_create: 'Create',
                    create_span: 'Create',
                    event_span: 'Event',
                    event_name: 'Event Name',
                    category: 'Category',
                    date: 'Date',
                    guest_count: 'Guest Count',
                    review_requests: 'Review Requests',
                    recieved_reviews: 'Received Testimonials',
                    qr_code: 'QR Code'
                },
                view_event: {
                    headre: 'Events',
                    btn_create: 'Create an Events',
                    no_events_found: 'No events found.',
                    menu_edit: 'Edit',
                    menu_delete: 'Delete',
                    name: 'Name',
                    category: "Category",
                    date: "Date",
                    event_QR_code: "Event QR Code",
                    copy: "Copy",
                    copied: "Copied",
                    download_QR: "Download QR",
                    add_media: "Add Media",
                    view_media: "View Media",
                    event_span: 'Event',
                    event_name: 'Event Name',
                    category: 'Category',
                    date: 'Date',
                    guest_count: 'Guest Count',
                    review_requests: 'Review Requests',
                    recieved_reviews: 'Received Testimonials',
                    qr_code: 'QR Code'
                },
                add_guest: {
                    error_msg: "Please fill in all required fields (*)",
                    toast_error: "Somthing went Wrong.try again.",
                    toast_submit: 'Add Guest Succefully',
                    edit_title: 'Edit Guest details',
                    page_header: 'Add a Guest',
                    account_type_title: 'Account type',
                    account_type_placeholder: '-- Select account type --',
                    // select_demo: 'Demo',
                    select_event: 'Event',
                    select_event_placeholder: '-- Select Event --',
                    first_name: 'First name',
                    first_name_placeholder: 'Enter first name',
                    last_name: 'Last name',
                    last_name_placeholder: 'Enter last name',
                    email: 'Email ID',
                    email_placeholder: 'Enter email ID',
                    phone: 'Phone number',
                    phone_placeholder: 'Enter phone number',
                    btn_cancel: 'Cancel',
                    welcome_message: 'Welcome to your test area!',
                    how_to_proceed: 'How to proceed?',
                    personalize_message: 'Personalize your message',
                    personalize_message_desc: 'Add a personal touch to make your request even more personal and warmer.',
                    add_details: 'Add details',
                    add_details_desc: 'Mention important information such as the date of the event and the type of testimonial required.',
                    explore_platform: 'Explore our platform and discover how it can transform your events into unforgettable moments.',
                    btn_update: 'Update',
                    toast_update: 'Guest details updated successfully',
                    update_errormsg: 'Error updating guest details',
                    upload_csv_file: 'Upload CSV File',
                    browseFile: 'Browse',
                    upgrade_your_plan: 'Upgrade Your Plan',
                    no_plan_found: 'Active Plan Not Found!',
                    limit_exceeded_csv_msg: `You have exceeded the allowed limit! Please remove some Guest's Name and try again.`,
                    limit_exceeded_msg: 'Your guest limit has been exceeded! Would you like to upgrade your plan?',
                    btn_upgrade: 'Upgrade',
                    no_active_plan: 'No Active Plan',
                    no_active_plan_msg: 'It looks like you don’t have a plan yet! Unlock all features by choosing a plan that suits you.',
                    btn_purchase: 'Purchase',
                    example_csv_1: 'you can download the example csv file by ',
                    example_csv_2: 'clicking here...',
                },
                Your_guest: {
                    header: "Guests List",
                    guest_search: 'Search',
                    // selectall: "All",
                    // selectallevent: "All Event",
                    btn_guest: 'Add a Guest',
                    // select_demo: 'Demo',
                    // select_event: 'Event',
                    guestName: "Guests Name",
                    emailId: "Email ID",
                    phoneNumber: "Phone Number",
                    function: "Functions",
                    event_name: "Event Name",
                    sendNow: 'Send Now',
                    menu: "Menu",
                    send: "Send",
                    sent: "Sent"
                },
                configuration: {
                    page_header: 'Your Emails',
                    accordion_title: 'Send email for guests review.',
                    accordion_subject_title: 'subject',
                    accordion_subject: 'We value your feedback - guests review request',
                    accordion_description_title: 'Description',
                    accordion_description: 'We hope this message finds you well. At [Your Show or Event Name], we strive to provide the best possible experience for our valued customers. Your satisfactˀˀion is of the utmost importance to us.We would greatly appreciate it if you could take a few moments to share your thoughts on your recent experience with our products/services. Your feedback is invaluable to us and helps us continually improve and enhance the quality of our offerings.Your honest opinions are important to us, and we thank you in advance for taking the time to provide your feedback. If you have any specific comments, suggestions, or concerns, please feel free to include them in your review or reply to this email directly.',
                    accordion_bestregard_title: 'Best Regard,',
                    accordion_bestregard: 'John Doe',
                    accordian_btn_save: 'Save',
                    accordian_btn_cancel: 'Cancel',
                },
                rate: {
                    title: "Rate",
                    basic: {
                        title: "Basic",
                        guests: "Number of guests",
                        range: "0 to 60",
                        price: "19 € INCL. VAT",
                        current_plan: "Your current plan"
                    },
                    pro: {
                        title: "Pro",
                        guests: "Number of guests",
                        range: "61 to 130",
                        price: "39 € INCL. VAT",
                        purchase: "Purchase"
                    },
                    premium: {
                        title: "Premium",
                        guests: "Number of guests",
                        range: "131 to 300",
                        price: "79 € INCL. VAT",
                        additional_guest: "0.27 / additional guest",
                        purchase: "Purchase"
                    },
                    all_subscriptions_includes: "All our subscriptions include:",
                    video: "Video collection and storage for one year.",
                    Personalized: "Personalized message to request video testimonials by email. Creation of a QR code to display at your event.",
                    Upload: "Upload your videos from your space."

                },
                your_testimonial: {
                    header: "Guests Review List",
                    selectall: "All",
                    demoOption: "Demo",
                    eventOption: "Event",
                    guestName: "Guests Name",
                    emailId: "Email ID",
                    phoneNumber: "Phone Number",
                    review: "Review",
                    menu: "Menu",
                    testimonialDetails: "Testimonial Details",
                    basicDetails: "Basic Details",
                    name: "Name",
                    email: "Email",
                    phone: "Phone",
                    event: "Event",
                    dateNtime: "Date And Time",
                    delete: "Delete",
                    cancel: "Cancel",
                    conformationOfDelete: "Are you sure you want to delete this review?",
                    plan_limit_exceeded_msg: "Upgrade your plan to unlock all reviews and premium features.",
                    upgrade_btn: "Upgrade Now"
                },
                qr_code: {
                    page_title: 'QR CODE',
                    whats_the_qr_code: "What's the QR code for?",
                    qr_code_description: "The QR code is a powerful tool for collecting video testimonials from your guests simply and efficiently. By scanning the code with their smartphone, your guests will be taken directly to the testimonial submission page, making it easy for them to participate.",
                    why_use_qr_code: 'Why use QR codes?',
                    easy_access_span: 'Easy access:',
                    easy_access: ' No need for complicated links or lengthy explanations. A simple scan and your guests can start recording their testimonials.',
                    save_time_span: 'Save time:',
                    save_time: ' Make the process easier for your guests, increasing the chances of collecting more spontaneous, authentic testimonials.',
                    modern_interaction_span: 'Modern interaction:',
                    modern_interaction: ' Using a QR code adds a modern, technological touch to your event, impressing your guests and making the experience more memorable.',
                    how_to_download_qr: 'How to download and use your QR code:',
                    step1_title: 'QR code generation:',
                    step1_desc: 'Once your event has been set up, we automatically generate a unique QR code for your event.',
                    step2_title: 'Download:',
                    step2_desc: 'Click on the button below to download your QR code in high quality.',
                    step3_title: 'Display:',
                    step3_desc: 'Print out the QR code and display it at your event in strategic locations such as the entrance, guest tables, or next to the guest book.',
                    ideas_for_using_qr: '3 Ideas for using your QR code:',
                    idea1_title: 'At the event entrance:',
                    idea1_desc: 'Place the QR code at the entrance so that guests can scan it as soon as they arrive. This allows them to participate right from the start and get involved in the event.',
                    idea2_title: 'On guest tables:',
                    idea2_desc: 'Place the QR code on each table or in the centerpieces. Guests will be able to scan it comfortably from their seats and register their testimonials during meals or breaks.',
                    idea3_title: 'Next to the guest book:',
                    idea3_desc: 'Place the QR code next to the guest book or gift drop zone. Guests who wish to leave a written message can also record a video testimony quickly.',
                },
                video_tutorials: {
                    header: 'Video Tutorials',
                    welcome_message: 'Welcome to our video tutorials area! Here you\'ll find step-by-step guides to help you get the most out of our platform.',
                    description: 'Watch our videos to learn how to set up your events, customize your testimonial requests, manage your contacts, and much more.',
                    card_title: 'Tutorial',
                    tutorial_card_title: 'Lorem ipsum',
                    tutorial_card_description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Saepe harum ut sapiente. Dolor rerum atque, aut quis dignissimos, ipsum molestiae quod neque animi, architecto odit eveniet dolorum pariatur voluptatum dicta.',
                },
                contact_us: {
                    header: 'Contact Us',
                    need_help: 'Need help or more information?',
                    description: 'We\'re here to help! If you have any questions or need assistance, please don\'t hesitate to send us a message. Our team is ready to answer all your questions and help you organize your events.',
                    first_name_label: 'First name',
                    last_name_label: 'Last name',
                    email_label: 'Email',
                    message_label: 'Your message',
                    placeholder_first_name: 'Enter first name',
                    placeholder_last_name: 'Enter last name',
                    placeholder_email: 'Enter email id',
                    placeholder_message: 'Write your message here',
                    cancel_button: 'Cancel',
                    submit_button: 'Submit',
                    toast_error: 'Please fill all fields',
                    toast_submit: 'Data Submited Succefully',
                },
                configuration_modal: {
                    header: "Configure your testimonial request emails",
                    description: "Welcome to the email configuration tool! Here you can customize your messages to invite your friends and family to share their stories.",
                    how_to_proceed: "How to proceed?",
                    personalize_message: "Personalize your message",
                    personalize_message_desc: "Add a personal touch to make your request even more personal and warmer.",
                    add_details: "Add details",
                    add_details_desc: "Mention important information such as the date of the event and the type of testimonial required.",
                    use_examples: "Use our examples",
                    use_examples_desc: "Consult the sample texts provided for inspiration and creation of engaging messages.",
                    create_messages_desc: "Take a few minutes to create engaging messages that will encourage your guests to share their special moments.",
                    confirm_sending: "Confirm sending",
                    confirm_sending_desc: "Choose the day and time for sending messages. Make sure everything is ready to capture testimonials at the right time."
                },
                YourGuestModal: {
                    welcome_message: "Welcome to your test area! 🎉",
                    with_your_demo: "With your demo account, you can :",

                    title1: "Create up to 3 guests", description1: "Manually add up to 3 contacts to test our solution.",
                    title2: "Fast delivery of testimonial requests", description2: "Your guests will receive the video testimonial request within seconds of sending it.",
                    title3: "Retrieve your test videos", description3: "Access all test videos collected in the Testimonials area.",

                    explore_platform: "Explore our platform and see for yourself how it can capture precious, authentic memories.",
                    contact_info: "For any request, please contact us using the contact form."
                },
                paymentModal: {
                    title: "Thank you for your purchase!",
                    message: "We have received your payment. The programming of your event is now registered.",
                    nextStep: {
                        title: "Next step:",
                        message: "Don't forget to download your QR code and display it at your event to get as many testimonials as possible."
                    },
                    downloadQrButton: "Download QR",
                    bestRegards: "Best regards,",
                    teamName: "The Happiclips team"
                },
                AddGuestModal: {
                    welcomeMessage: "Welcome to your event space! 🎉",
                    gettingStarted: "Getting started:",
                    step1: {
                        title: "Choose your event",
                        description: "Select the event for which you wish to import contacts."
                    },
                    step2: {
                        title: "Import contacts",
                        description: "Use our CSV import tool to easily add all your contacts."
                    },
                    step3: {
                        title: "Add contacts manually",
                        description: "You can also add contacts manually, one by one."
                    },
                    additionalInfo: "Take advantage of our tools to simplify your contact management and capture unforgettable testimonials."
                },
                EventModal: {
                    title: "We're delighted to see you here. 🎉",
                    description: "To start your adventure with us, create your first event now. Set it up easily and take advantage of a free trial to discover all the features we have to offer.",

                    sub_title: "Why create your event?",
                    title1: "Simplicity",
                    description1: "An intuitive interface for quick, no-hassle configuration effort.",
                    title2: "Free trial",
                    description2: "Test all the features for free and see for yourself how easy it is to capture precious memories.",
                    tutorialsInfo: {
                        sub_description: 'New to the platform ? ',
                        description: "Check out our step-by-step tutorials to get the most out of our tools. ",
                        description1: 'to access the tutorials.',
                        linkText: "Click here",
                        linkUrl: "Click"
                    },
                    createEvent: {
                        description: " on the button below to create your first event and start capturing unforgettable moments!",

                    }
                },
                DeleteModal: {
                    title: "Are you Sure?",
                    description: "Do you really want to delete these records?",
                    cancelButton: "Cancel",
                    deleteButton: "Delete",
                    deleteMessage: 'Delete data suceesfully',
                    delete_errormessage: "Error deleting event details !!",
                },
                SettingModal: {
                    title: "Settings",
                    description: "Please select a preferred language",
                    eng: "English",
                    frn: "French",


                },
                CreateEventModal: {
                    titlemodal: "Edit event details",
                    nameLabel: "Show name",
                    namePlaceholder: "Enter show name",
                    dateLabel: "Date",
                    categoryLabel: "Category",
                    selectCategory: "-- Select show category --",
                    createButton: "Create",
                    create_event: "Create Event",
                    btn_create: "Create",
                    successMessage: "Event created successfully!",
                    errorMessage: "Error creating event!",
                    update_errormsg: "Error updating event details",
                    update_success: "update event detail Succefully",
                    toastError: "Please fill all fields",
                    btn_cancel: 'Cancel',
                    btn_update: 'Update'
                },
                EditModal: {

                },
                login: {
                    main_title: "Welcome Back!",
                    main_subtitle: "Create unforgettable memories with Happiclips, your video testimonial collection tool.",
                    description: "Whether for a wedding, an anniversary or any other special event, we're here to help you capture every precious moment.",
                    signup_button: "Sign Up",
                    title: "Sign in your account",
                    subtitle: "Please enter your personal details below.",
                    email_label: "Email id or phone number",
                    email_placeholder: "Enter email id or phone number",
                    password_label: "Password",
                    password_placeholder: "Enter password",
                    sign_in_button: "Sign In",
                    signing_in: "Signing In...",
                    forgot_password: "Forgot Password?",
                    toast_success: 'Login successful!',
                    invalid_toast: 'Invalid email or password',
                    error_msg: "Please fill all fields",
                    no_account: "Don't have an account?"
                },
                signup: {
                    main_title: "Good Morning!",
                    main_subtitle: "Create unforgettable memories with Happiclips, your video testimonial collection tool.",
                    description: "Whether for a wedding, an anniversary or any other special event, we're here to help you capture every precious moment.",
                    signin_button: "Sign In",
                    title: "Create your account",
                    subtitle: "Please enter your personal detail below.",
                    name_label: "Name",
                    name_placeholder: "Enter your full name",
                    phone_label: "Phone no.",
                    phone_placeholder: "Enter phone no.",
                    city_label: "City",
                    city_placeholder: "Enter city",
                    email_label: "Email",
                    email_placeholder: "Enter email id",
                    address_label: "Address",
                    address_placeholder: "Enter Address",
                    postal_code_label: "Postal code",
                    postal_code_placeholder: "Enter postal code",
                    password_label: "Password",
                    password_placeholder: "Enter password",
                    confirm_password_label: "Confirm password",
                    confirm_password_placeholder: "Enter confirm password",
                    signup_button: "Sign Up",
                    signing_up: "Signing up...",
                    toast_submit: 'Registartion successfully',
                    error_msg: "Please fill all fields",
                    error_psw: 'password and confirm password must be same!',
                    error_email: "enter valid email!",
                    have_account: "Do you already have an account?"
                }

            },
            fr: {
                guestmedia: {
                    upload_photo_n_video: "Téléverser des photos et vidéos",
                    drag_n_drop: "Glissez-déposez vos médias",
                    select_files: "ou cliquez pour sélectionner des fichiers",
                    choose_files: "Choisir les fichiers",
                    selected_files: "Fichiers sélectionnés",
                    cancel: "Annuler",
                    uploading: "Téléversement en cours...",
                    upload: "Téléverser"
                },
                media_gallery: {
                    title_media_gallery: "Galerie Média",
                    manage_image_n_video: "Gérez vos images et vidéos",
                    deleteMessage: "Données supprimées avec succès",
                    delete_media: "Supprimer le média",
                    delete_media_description: "Êtes-vous sûr de vouloir supprimer ce fichier média ? Cette action est irréversible.",
                    cancel: "Annuler",
                    delete: "Supprimer",
                    add_media: "Ajouter un média",
                    upload_media: "Téléverser un média",
                    choose_files_to_upload: "Choisissez les fichiers à téléverser",
                    drag_n_drop: "Ou glissez-déposez • Images et vidéos uniquement",
                    selected_files: "Fichiers sélectionnés",
                    upload: "Téléverser",
                    loading: "Chargement...",
                    load_more: "Charger plus",
                    photo: "Photo",
                    video: "Vidéo",
                    all: "Tous",
                    no_media_found: "Aucun média trouvé"

                },
                resetpassword: {
                    main_title: "Réinitialiser le mot de passe",
                    description: "Créez un nouveau mot de passe pour sécuriser votre compte.",
                    title: "Définir un nouveau mot de passe",
                    subtitle: "Entrez votre nouveau mot de passe ci-dessous.",
                    password_label: "Nouveau mot de passe",
                    password_placeholder: "Entrez le nouveau mot de passe",
                    confirm_password_label: "Confirmer le mot de passe",
                    confirm_password_placeholder: "Saisissez à nouveau le mot de passe",
                    submit_button: "Réinitialiser le mot de passe",
                    error_required: "Tous les champs sont requis.",
                    error_mismatch: "Les mots de passe ne correspondent pas.",
                    error_generic: "Une erreur s'est produite.",
                    success_message: "Le mot de passe a été réinitialisé avec succès !"
                },
                forgotpassword: {
                    main_title: "Mot de passe oublié ?",
                    description: "Récupérez votre compte rapidement et en toute sécurité.",
                    title: "Réinitialiser votre mot de passe",
                    subtitle: "Entrez votre adresse e-mail pour recevoir un lien de réinitialisation",
                    email_label: "Adresse e-mail",
                    email_placeholder: "Entrez votre adresse e-mail enregistrée",
                    submit_button: "Envoyer le lien",
                    signin_button: "Se connecter",
                    remembered: "Vous vous souvenez de votre mot de passe ?",
                    error_empty: "L'e-mail est requis.",
                    error_invalid: "Entrez une adresse e-mail valide.",
                    error_generic: "Une erreur s'est produite.",
                    success_message: "Le lien de réinitialisation du mot de passe a été envoyé avec succès !"
                },
                navbar: {
                    greeting: 'Salut',
                    date_time: 'Nous sommes le 22 juillet 2024. 16h24',
                    profile: 'Profil',
                    logout: 'Se déconnecter ',
                    cancel: 'annuler',
                    logoutConformation: 'Etes-vous sûr de vouloir vous déconnecter ?'
                },
                profilePage: {
                    profile: 'Profil',
                    name: 'Nom',
                    placeholder_name: 'Entrez votre nom',
                    email: 'Email',
                    placeholder_email: 'Entrez votre email',
                    phone_no: 'numéro de téléphone',
                    placeholder_phone_no: 'Entrez votre numéro de téléphone',
                    address: 'adresse',
                    placeholder_address: 'Entrez votre adresse',
                    postal_code: 'Code postal',
                    placeholder_postal_code: 'Entrez votre code postal',
                    city: 'Ville',
                    placeholder_city: 'Entrez votre ville',
                    cancel: 'annuler',
                    save: 'Enregistrer'
                },
                dashboardLayout: {
                    dashboard: "Tableau de bord",
                    events: "Événements",
                    configuration: "Vos Emails",
                    addYourGuests: "Ajouter vos invités",
                    yourGuests: "Vos invités",
                    rate: "Tarif",
                    yourTestimonials: "Vos témoignages",
                    qrCode: "QR Code",
                    videoTutorials: "Tutoriels vidéo",
                    contactUs: "Contactez-nous",
                    logOut: "Se déconnecter",
                    cancel: 'annuler',
                    logoutConformation: 'Etes-vous sûr de vouloir vous déconnecter ?'
                },
                event: {
                    headre: 'Événements',
                    btn_create_event: 'Créer un événement',
                    btn_create: 'Créer',
                    create_span: 'Créer',
                    event_span: 'Événement',
                    event_name: 'Nom de l\'événement',
                    category: 'Catégorie',
                    date: 'Date',
                    guest_count: 'Nombre d\'invités',
                    review_requests: 'Nombre de demandes de témoignage',
                    recieved_reviews: 'Nombre de témoignages reçus',
                    qr_code: 'Code QR'
                },
                view_event: {
                    headre: 'Événements',
                    btn_create: 'Créer un événement',
                    no_events_found: 'Aucun événement trouvé.',
                    menu_edit: 'Modifier',
                    menu_delete: 'Supprimer',
                    name: 'Nom',
                    category: "Catégorie",
                    date: "Date",
                    event_QR_code: "Code QR de l'événement",
                    copy: "Copier",
                    copied: "Copié",
                    download_QR: "Télécharger le QR",
                    add_media: "Ajouter un média",
                    view_media: "Voir les médias",
                    event_span: 'Événement',
                    event_name: 'Nom de l\'événement',
                    category: 'Catégorie',
                    date: 'Date',
                    guest_count: 'Nombre d\'invités',
                    review_requests: 'Nombre de demandes de témoignage',
                    recieved_reviews: 'Nombre de témoignages reçus',
                    qr_code: 'Code QR'
                },
                add_guest: {
                    error_msg: "Veuillez remplir tous les champs obligatoires (*)",
                    toast_error: "Quelque chose s'est mal passé. Réessayez.",
                    toast_submit: 'Ajouter un invité avec succès',
                    edit_title: "Modifier les détails de l'invité",
                    page_header: 'Ajouter un invité',
                    account_type_title: 'Type de compte',
                    account_type_placeholder: '-- Sélectionnez le type de compte --',
                    // select_demo: 'Démo',
                    select_event: 'Événement',
                    select_event_placeholder: '-- Sélectionnez un événement --',
                    first_name: 'Prénom',
                    first_name_placeholder: 'Entrez le prénom',
                    last_name: 'Nom de famille',
                    last_name_placeholder: 'Entrez le nom de famille',
                    email: 'ID Email',
                    email_placeholder: "Entrez l'identifiant de messagerie",
                    phone: 'Numéro de téléphone',
                    phone_placeholder: 'Entrez le numéro de téléphone',
                    btn_cancel: 'Annuler',
                    welcome_message: 'Bienvenue dans votre zone de test!',
                    how_to_proceed: 'Comment procéder?',
                    personalize_message: 'Personnalisez votre message',
                    personalize_message_desc: 'Ajoutez une touche personnelle pour rendre votre demande encore plus chaleureuse.',
                    add_details: 'Ajoutez des détails',
                    add_details_desc: 'Mentionnez des informations importantes telles que la date de l\'événement et le type de témoignage requis.',
                    explore_platform: 'Explorez notre plateforme et découvrez comment elle peut transformer vos événements en moments inoubliables.',
                    btn_update: 'Mise à jour',
                    toast_update: 'Les détails des invités ont été mis à jour avec succès',
                    update_errormsg: 'Erreur lors de la mise à jour des détails du voyageur',
                    upload_csv_file: 'Téléverser un fichier CSV',
                    browseFile: 'Parcourir',
                    upgrade_your_plan: 'Mettez à niveau votre plan.',
                    no_plan_found: 'Plan actif non trouvé !',
                    limit_exceeded_csv_msg: `Vous avez dépassé la limite autorisée ! Veuillez supprimer certains noms d'invités et réessayer.`,
                    limit_exceeded_msg: `Votre limite d'invités a été dépassée ! Souhaitez-vous mettre à niveau votre plan ?`,
                    btn_upgrade: 'Mettre à niveau',
                    no_active_plan: 'Aucun plan actif',
                    no_active_plan_msg: `Il semble que vous n'ayez pas encore de plan ! Débloquez toutes les fonctionnalités en choisissant un plan qui vous convient.`,
                    btn_purchase: 'Achat',
                    example_csv_1: `vous pouvez télécharger l'exemple de fichier CSV par `,
                    example_csv_2: 'cliquant ici...',
                },
                Your_guest: {
                    header: "Liste des invités",
                    guest_search: 'Recherche',
                    // selectall: "Tout",
                    // selectallevent: "Tous les événements",
                    btn_guest: 'Ajouter un invité',
                    // select_demo: 'Démo',
                    // select_event: 'Événement',
                    guestName: "Nom de l'invité",
                    emailId: "ID Email",
                    phoneNumber: "Numéro de téléphone",
                    function: "Fonctions",
                    event_name: "Nom de l'événement",
                    sendNow: 'Envoyer maintenant',
                    menu: "Menu",
                    send: "Envoyer",
                    sent: "Envoyé"
                },
                configuration: {
                    page_header: 'Vos Emails',
                    accordion_title: "GSenvoyez un e-mail pour l'avis des clients.",
                    accordion_subject_title: 'sujet',
                    accordion_subject: "Nous apprécions vos commentaires - demande d'avis des clients ",
                    accordion_description_title: 'Description',
                    accordion_description: "Nous espérons que ce message vous trouvera bien. Chez [Votre nom de votre spectacle ou de votre événement], nous nous efforçons de fournir la meilleure expérience possible à nos précieux clients. Votre satisfaction est de la plus haute importance pour nous.Nous apprécierions grandement que vous preniez quelques instants pour partager vos réflexions sur votre récente expérience avec nos produits/services. Vos commentaires nous sont inestimables et nous aident à améliorer et à améliorer continuellement la qualité de nos offres.Vos opinions honnêtes sont importantes pour nous et nous vous remercions d'avance d'avoir pris le temps de nous faire part de vos commentaires. Si vous avez des commentaires, suggestions ou préoccupations spécifiques, n'hésitez pas à les inclure dans votre avis ou à répondre directement à cet e-mail.",
                    accordion_bestregard_title: 'Meilleure considération,',
                    accordion_bestregard: 'John Doe',
                    accordian_btn_save: 'Sauvegarder',
                    accordian_btn_cancel: 'Annuler',
                },
                rate: {
                    title: "Tarif",
                    basic: {
                        title: "De base",
                        guests: "Nombre d'invités",
                        range: "0 à 60",
                        price: "19 € TTC",
                        current_plan: "Votre plan actuel"
                    },
                    pro: {
                        title: "Pro",
                        guests: "Nombre d'invités",
                        range: "61 à 130",
                        price: "39 € TTC",
                        purchase: "Acheter"
                    },
                    premium: {
                        title: "Premium",
                        guests: "Nombre d'invités",
                        range: "131 à 300",
                        price: "79 € TTC",
                        additional_guest: "0,27 € / invité supplémentaire",
                        purchase: "Acheter"
                    },
                    all_subscriptions_includes: "Toutes nos souscriptions comprennent :",
                    video: "Collecte et stockage des vidéos pendant un an.",
                    Personalized: "Message personnalisé pour demander des témoignages vidéo par email. Création d'un QR code à afficher lors de votre événement.",
                    Upload: "Téléchargez vos vidéos depuis votre espace."

                },
                your_testimonial: {
                    header: "Liste des avis des invités",
                    selectall: "Tout",
                    demoOption: "Démo",
                    eventOption: "Événement",
                    guestName: "Nom de l'invité",
                    emailId: "ID Email",
                    phoneNumber: "Numéro de téléphone",
                    review: "Avis",
                    menu: "Menu",
                    testimonialDetails: "Détails du témoignage",
                    basicDetails: "Détails de base",
                    name: "Nom",
                    email: "Email",
                    phone: "Téléphone",
                    event: "Événement",
                    dateNtime: "Date et heure",
                    delete: "supprimer",
                    cancel: "annuler",
                    conformationOfDelete: "Êtes-vous sûr de vouloir supprimer cet avis ?",
                    plan_limit_exceeded_msg: "Mettez à niveau votre forfait pour débloquer tous les avis et bénéficier de fonctionnalités premium.",
                    upgrade_btn: "Mettez à niveau maintenant"
                },
                qr_code: {
                    page_title: 'CODE QR',
                    whats_the_qr_code: "À quoi sert le QR code ?",
                    qr_code_description: "Le QR code est un outil puissant pour collecter des témoignages vidéo de vos invités de manière simple et efficace. En scannant le code avec leur smartphone, vos invités seront directement dirigés vers la page de soumission des témoignages, ce qui leur facilitera la participation.",
                    why_use_qr_code: 'Pourquoi utiliser des QR codes ?',
                    easy_access_span: 'Accès facile :',
                    easy_access: ' Pas besoin de liens compliqués ou d’explications longues. Un simple scan et vos invités peuvent commencer à enregistrer leurs témoignages.',
                    save_time_span: 'Gagner du temps :',
                    save_time: ' Simplifiez le processus pour vos invités, augmentant ainsi les chances de recueillir plus de témoignages spontanés et authentiques.',
                    modern_interaction_span: 'Interaction moderne :',
                    modern_interaction: ' Utiliser un QR code ajoute une touche moderne et technologique à votre événement, impressionnant vos invités et rendant l\'expérience plus mémorable.',
                    how_to_download_qr: 'Comment télécharger et utiliser votre QR code :',
                    step1_title: 'Génération du QR code :',
                    step1_desc: 'Une fois votre événement configuré, nous générons automatiquement un QR code unique pour votre événement.',
                    step2_title: 'Téléchargement :',
                    step2_desc: 'Cliquez sur le bouton ci-dessous pour télécharger votre QR code en haute qualité.',
                    step3_title: 'Affichage :',
                    step3_desc: 'Imprimez le QR code et affichez-le lors de votre événement dans des endroits stratégiques comme l’entrée, les tables des invités ou à côté du livre d’or.',
                    ideas_for_using_qr: '3 idées pour utiliser votre QR code :',
                    idea1_title: 'À l\'entrée de l\'événement :',
                    idea1_desc: 'Placez le QR code à l\'entrée pour que les invités puissent le scanner dès leur arrivée. Cela leur permet de participer dès le début et de s’impliquer dans l’événement.',
                    idea2_title: 'Sur les tables des invités :',
                    idea2_desc: 'Placez le QR code sur chaque table ou dans les centres de table. Les invités pourront le scanner confortablement depuis leur siège et enregistrer leurs témoignages pendant les repas ou les pauses.',
                    idea3_title: 'À côté du livre d’or :',
                    idea3_desc: 'Placez le QR code à côté du livre d’or ou de la zone de dépôt des cadeaux. Les invités qui souhaitent laisser un message écrit pourront également enregistrer un témoignage vidéo rapidement.',
                },
                video_tutorials: {
                    header: 'Tutoriels vidéo',
                    welcome_message: 'Bienvenue dans notre espace de tutoriels vidéo ! Ici, vous trouverez des guides étape par étape pour vous aider à tirer le meilleur parti de notre plateforme.',
                    description: 'Regardez nos vidéos pour apprendre à configurer vos événements, personnaliser vos demandes de témoignages, gérer vos contacts et bien plus encore.',
                    card_title: 'Tutoriel',
                    tutorial_card_title: 'Lorem ipsum',
                    tutorial_card_description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Saepe harum ut sapiente. Dolor rerum atque, aut quis dignissimos, ipsum molestiae quod neque animi, architecto odit eveniet dolorum pariatur voluptatum dicta.',
                },
                contact_us: {
                    header: 'Contactez-nous',
                    need_help: 'Besoin d\'aide ou de plus d\'informations ?',
                    description: 'Nous sommes là pour vous aider ! Si vous avez des questions ou avez besoin d\'assistance, n\'hésitez pas à nous envoyer un message. Notre équipe est prête à répondre à toutes vos questions et à vous aider à organiser vos événements.',
                    first_name_label: 'Prénom',
                    last_name_label: 'Nom de famille',
                    email_label: 'Email',
                    message_label: 'Votre message',
                    placeholder_first_name: 'Entrez le prénom',
                    placeholder_last_name: 'Entrez le nom de famille',
                    placeholder_email: 'Entrez l\'email',
                    placeholder_message: 'Écrivez votre message ici',
                    cancel_button: 'Annuler',
                    submit_button: 'Soumettre',
                    toast_error: 'Veuillez remplir tous les champs',
                    toast_submit: 'Données soumises avec succès',
                },
                configuration_modal: {
                    header: "Configurez vos e-mails de demande de témoignages",
                    description: "Bienvenue dans l'outil de configuration des e-mails ! Ici, vous pouvez personnaliser vos messages pour inviter vos amis et votre famille à partager leurs histoires.",
                    how_to_proceed: "Comment procéder ?",
                    personalize_message: "Personnalisez votre message",
                    personalize_message_desc: "Ajoutez une touche personnelle pour rendre votre demande encore plus chaleureuse et personnelle.",
                    add_details: "Ajoutez des détails",
                    add_details_desc: "Mentionnez des informations importantes telles que la date de l'événement et le type de témoignage requis.",
                    use_examples: "Utilisez nos exemples",
                    use_examples_desc: "Consultez les textes exemples fournis pour vous inspirer et créer des messages engageants.",
                    create_messages_desc: "Prenez quelques minutes pour créer des messages engageants qui encourageront vos invités à partager leurs moments spéciaux.",
                    confirm_sending: "Confirmer l'envoi",
                    confirm_sending_desc: "Choisissez le jour et l'heure de l'envoi des messages. Assurez-vous que tout est prêt pour capturer des témoignages au bon moment."
                },
                YourGuestModal: {
                    welcome_message: "Bienvenue dans votre zone de test! 🎉",
                    with_your_demo: "Avec votre compte démo, vous pouvez :",

                    title1: "Créer jusqu'à 3 invités", description1: "Ajoutez manuellement jusqu'à 3 contacts pour tester notre solution.",
                    title2: "Envoi rapide des demandes de témoignages", description2: "Vos invités recevront la demande de témoignage vidéo dans les secondes suivant son envoi.",
                    title3: "Récupérez vos vidéos de test", description3: "Accédez à toutes les vidéos de test collectées dans la section Témoignages.",

                    explore_platform: "Explorez notre plateforme et voyez par vous-même comment elle peut capturer des souvenirs précieux et authentiques.",
                    contact_info: "Pour toute demande, veuillez nous contacter via le formulaire de contact."
                },
                paymentModal: {
                    title: "Merci pour votre achat!",
                    message: "Nous avons bien reçu votre paiement. La programmation de votre événement est maintenant enregistrée.",
                    nextStep: {
                        title: "Prochaine étape :",
                        message: "N'oubliez pas de télécharger votre code QR et de l'afficher lors de votre événement pour obtenir autant de témoignages que possible."
                    },
                    downloadQrButton: "Télécharger le QR",
                    bestRegards: "Meilleures salutations,",
                    teamName: "L'équipe Happiclips"
                },
                AddGuestModal: {
                    welcomeMessage: "Bienvenue dans votre espace événementiel! 🎉",
                    gettingStarted: "Commencer:",
                    step1: {
                        title: "Choisissez votre événement",
                        description: "Sélectionnez l'événement pour lequel vous souhaitez importer des contacts."
                    },
                    step2: {
                        title: "Importer des contacts",
                        description: "Utilisez notre outil d'importation CSV pour ajouter facilement tous vos contacts."
                    },
                    step3: {
                        title: "Ajouter des contacts manuellement",
                        description: "Vous pouvez également ajouter des contacts manuellement, un par un."
                    },
                    additionalInfo: "Profitez de nos outils pour simplifier la gestion de vos contacts et capturer des témoignages inoubliables."
                },
                EventModal: {
                    title: "Nous sommes ravis de vous voir ici. 🎉",
                    description: "Pour commencer votre aventure avec nous, créez dès maintenant votre premier événement. Configurez-le facilement et profitez d'un essai gratuit pour découvrir toutes les fonctionnalités que nous avons à offrir.",

                    sub_title: "Pourquoi créer votre événement ?",


                    title1: "Simplicité",
                    description1: "Une interface intuitive pour une configuration rapide et sans tracas.",

                    title2: "Essai gratuit",
                    description2: "Testez toutes les fonctionnalités gratuitement et voyez par vous-même à quel point il est facile de capturer des souvenirs précieux.",


                    tutorialsInfo: {
                        sub_description: 'Vous êtes nouveau sur la plateforme ?',
                        description: " Découvrez nos tutoriels étape par étape pour tirer le meilleur parti de nos outils.",
                        description1: 'pour accéder aux tutoriels.',
                        linkText: "Cliquez ici",
                        linkUrl: "Cliquez"
                    },
                    createEvent: {
                        description: " sur le bouton ci-dessous pour créer votre premier événement et commencer à capturer des moments inoubliables !",

                    }
                },
                DeleteModal: {
                    title: "Êtes-vous sûr?",
                    description: "Voulez-vous vraiment supprimer ces enregistrements?",
                    cancelButton: "Annuler",
                    deleteButton: "Supprimer",
                    deleteMessage: 'Supprimer les données avec succès',
                    delete_errormessage: "Erreur lors de la suppression des détails de l'événement !!",
                },
                SettingModal: {
                    title: "Paramètres",
                    description: "Veuillez sélectionner une langue préférée",
                    eng: "English",
                    frn: "Français",
                },
                CreateEventModal: {
                    titlemodal: "Modifier les détails de l'événement",
                    title: "Créer un événement",
                    nameLabel: "Nom du spectacle",
                    namePlaceholder: "Entrez le nom du spectacle",
                    dateLabel: "Date",
                    categoryLabel: "Catégorie",
                    selectCategory: "-- Sélectionner la catégorie du spectacle --",
                    createButton: "Créer",
                    create_event: "Créer un événement",
                    btn_cancel: "Annuler",
                    btn_create: "Créer",
                    successMessage: "Événement créé avec succès!",
                    errorMessage: "Erreur lors de la création de l'événement!",
                    update_errormsg: "Erreur lors de la mise à jour des détails du voyageur",
                    update_success: "mettre à jour les détails de l'événement avec succès",
                    toastError: "Veuillez remplir tous les champs",
                    btn_cancel: 'Annuler',
                    btn_update: 'Mise à jour'
                },
                EditModal: {

                },
                login: {
                    main_title: "Bon retour !",
                    main_subtitle: "Créez des souvenirs inoubliables avec Happiclips, votre outil de collecte de témoignages vidéo.",
                    description: "Que ce soit pour un mariage, un anniversaire ou tout autre événement spécial, nous sommes là pour vous aider à capturer chaque moment précieux.",
                    signup_button: "S'inscrire",
                    title: "Connectez-vous à votre compte",
                    subtitle: "Veuillez entrer vos coordonnées personnelles ci-dessous.",
                    email_label: "Email ou numéro de téléphone",
                    email_placeholder: "Entrez l'email ou le numéro de téléphone",
                    password_label: "Mot de passe",
                    password_placeholder: "Entrez le mot de passe",
                    sign_in_button: "Se connecter",
                    signing_in: "Connexion en cours...",
                    forgot_password: "Forgot Password?",
                    toast_success: 'Connexion réussie !',
                    invalid_toast: 'Invalid email or password',
                    error_msg: "Veuillez remplir tous les champs",
                    no_account: "Vous n'avez pas de compte ?"
                },
                signup: {
                    main_title: "Bonjour !",
                    main_subtitle: "Créez des souvenirs inoubliables avec Happiclips, votre outil de collecte de témoignages vidéo.",
                    description: "Que ce soit pour un mariage, un anniversaire ou tout autre événement spécial, nous sommes là pour vous aider à capturer chaque moment précieux.",
                    signin_button: "Se connecter",
                    title: "Créez votre compte",
                    subtitle: "Veuillez entrer vos coordonnées personnelles ci-dessous.",
                    name_label: "Nom",
                    name_placeholder: "Entrez votre nom complet",
                    phone_label: "Numéro de téléphone",
                    phone_placeholder: "Entrez votre numéro de téléphone",
                    city_label: "Ville",
                    city_placeholder: "Entrez votre ville",
                    email_label: "Email",
                    email_placeholder: "Entrez votre email",
                    address_label: "Adresse",
                    address_placeholder: "Entrez votre adresse",
                    postal_code_label: "Code postal",
                    postal_code_placeholder: "Entrez votre code postal",
                    password_label: "Mot de passe",
                    password_placeholder: "Entrez votre mot de passe",
                    confirm_password_label: "Confirmer le mot de passe",
                    confirm_password_placeholder: "Entrez le mot de passe de confirmation",
                    signup_button: "S'inscrire",
                    signing_up: "Inscription en cours...",
                    toast_submit: 'Inscription réussie',
                    error_msg: "Veuillez remplir tous les champs",
                    error_psw: 'le mot de passe et le mot de passe de confirmation doivent être identiques !',
                    error_email: "entrez un email valide!",
                    have_account: "Avez-vous déjà un compte ?"
                }
            }
        }
    }
    );
